module.exports = __webpack_public_path__ + "static/media/apng_weak_blue.aaca5e78.png";